<template>
  <div class="main-container">
    <div class="search-box btn3" :class="{ 'close': !searchMore }">
      <div class="input-item select-two">
        <Select v-model="searchParams.dateType" :transfer="true">
          <Option value="1">承保日期</Option>
          <Option value="2">支付日期</Option>
          <Option value="3">起保日期</Option>
        </Select>
        <DatePicker
          v-model="searchParams.date"
          type="daterange"
          split-panels
          separator=" 至 "
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">保险公司</span>
        <Select v-model="searchParams.companyCode" :transfer="true" filterable clearable>
          <Option v-for="(item, i) in companyList" :key="i" :value="item.code">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item select-two">
        <Select v-model="searchParams.orderType" :transfer="true">
          <Option value="1">保单号</Option>
          <Option value="2">订单号</Option>
        </Select>
        <Input v-model="searchParams.no" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">状态</span>
        <Select v-model="searchParams.statusList" multiple :max-tag-count="2" :transfer="true" clearable>
          <Option value="1">保障中</Option>
          <Option value="-1">退保</Option>
          <Option value="0">终止</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">产品名称</span>
        <Input v-model="searchParams.productName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">投保人名称</span>
        <Input v-model="searchParams.holderName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">投保人证件号</span>
        <Input v-model="searchParams.cardNo" placeholder="请输入" clearable />
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">搜索</Button>
        <Button type="primary" ghost @click="resetSearch">重置</Button>
        <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
          >收起
          <Icon type="ios-arrow-up" />
        </Button>
        <Button type="primary" ghost v-else @click="searchMore = true"
          >展开
          <Icon type="ios-arrow-down" />
        </Button>
      </div>
    </div>
    <div class="tools-box">
      <Button type="warning" @click="exportToExcel">导出</Button>
    </div>
    <div class="total-box">
      <span>
        共<b>{{ totalInfo.counts }}</b
        >单
      </span>
      <span>
        已支付保费：<b> {{ totalInfo.issueFee | number_format(2) }}</b
        >元
      </span>
      <span>
        退保保费：<b>{{ totalInfo.refundFee | number_format(2) }}</b
        >元
      </span>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="detail(row)">详情</span>
          <a v-if="row.policyUrl && (row.type == 1 || row.dockChannel == 3)" :href="row.policyUrl">
            <span class="table-btn">下载保单</span>
          </a>
          <span v-if="row.contract && row.contract.length > 0 && row.type == 2" class="table-btn" @click="goUnderlinePolicy(row)">电子保单</span>
        </template>
      </Table>
    </div>
    <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
    <Modal v-model="showPolicy" title="电子保单" width="800" :loading="$root.$children[0].modalLoading" footer-hide>
      <resource ref="resourceRef" :urlList="urlList" width="100px" height="100px"></resource>
    </Modal>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { pageTool } from '@/api/mixins';
import { mapState } from 'vuex';
import { config } from './index.config.js';
import resource from '@/components/commons/resource';
export default {
  mixins: [pageTool, config],
  components: {
    resource
  },
  data() {
    return {
      urlList: [], //资源列表
      showPolicy: false,
      listLoading: false,
      companyList: [],
      totalInfo: {}
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created() {
    this.tableData = [];
    this.getColumns();
    this.getCompanyList();
    this.initListParams('/buz/grouppolicy/read/list');
  },
  activated() {
    if(sessionStorage.queryPolicyNo) {
      this.searchParams.policyNo = sessionStorage.queryPolicyNo;
      sessionStorage.removeItem('queryPolicyNo');
    }
    this.getList();
  },
  methods: {
    listCallback(res) {
      res.data.forEach(item => {
        if (item.contract) {
          item.contract = JSON.parse(item.contract);
        }
      });
      this.getTotalInfo();
    },
    getTotalInfo() {
      let params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      this.$http({
        url: `/buz/grouppolicy/count`,
        type: 'POST',
        data: params
      }).then(res => {
        this.totalInfo = res.data;
      });
    },
    // 获取文件类型
    checkType(path) {
      return path && path.split('.').pop().toLowerCase();
    },
    goUnderlinePolicy(item) {
      if (item.contract.length > 1) {
        this.urlList = item.contract.map(i => {
          return { path: i.url, fileName: i.url.split('/')[i.url.split('/').length - 1] };
        });
        this.showPolicy = true;
      } else {
        let path = item.contract[0].url;
        if (['png', 'jpg', 'jpeg'].includes(this.checkType(path))) {
          this.urlList = item.contract.map(i => {
            return { path: i.url, fileName: i.url.split('/')[i.url.split('/').length - 1] };
          });
          this.showPolicy = true;
        } else if (this.checkType(path) == 'pdf') {
          window.open(path, '_blank');
        } else {
          location.href = path;
        }
      }
    },
    // 导出
    exportToExcel() {
      this.listLoading = true;
      let params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      this.$http({
        url: '/buz/grouppolicy/export',
        type: 'POST',
        responseType: 'blob',
        data: params
      })
        .then(res => {
          this.listLoading = false;
          this.$units.daochu(res);
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    detail(row = {}) {
      this.$router.push({
        path: '/orderManage/group/policyDetail',
        query: {
          id: row.id || '',
          policyNo: row.policyNo,
          orderNo: row.orderNo,
          dockChannel: row.dockChannel,
          payType: row.payType,
          productCategory: row.productCategory, //1-团险 2-财产险 3、个险
          status: row.status, //保单状态 1-保障中 -1-退保 0-终止
          type: row.type //1-桐心保平台单、2-商户录单
        }
      });
    },
    // 获取保司列表
    getCompanyList() {
      this.$http({
        url: `/buz/insuranceCompany/read/list`,
        type: 'POST',
        data: { companyType: '1' }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    // 转化参数
    setListParams(params) {
      delete params.applyOrgId;
      if (params.date && params.date[0]) {
        let date1 = dayjs(params.date[0]).format('YYYY-MM-DD');
        let date2 = dayjs(params.date[1]).format('YYYY-MM-DD');
        if (params.dateType == 1) {
          //承保日期
          params.issueTimeStart = date1;
          params.issueTimeEnd = date2;
        } else if (params.dateType == 2) {
          //支付日期
          params.payTimeStart = date1;
          params.payTimeEnd = date2;
        } else if (params.dateType == 3) {
          //起保日期
          params.startTimeStart = date1;
          params.startTimeEnd = date2;
        }
      }

      if (params.orderType && params.no) {
        if (params.orderType == 1) {
          params.policyNo = params.no;
        } else if (params.orderType == 2) {
          params.orderNo = params.no;
        }
      }
      delete params.no;
      delete params.orderType;
      delete params.dateType;
      delete params.date;
    }
  }
};
</script>
<style lang="scss" scoped>
.search-box {
  padding-right: 250px;
}

.tools-box {
  display: flex;
  justify-content: flex-end;
}

.total-box {
  padding-bottom: 15px;

  span {
    padding-right: 10px;
  }

  b {
    color: #236dff;
    font-weight: 400;
  }
}
</style>
